import { render } from "./FounderStorySection.vue?vue&type=template&id=295d6238"
import script from "./FounderStorySection.vue?vue&type=script&lang=js"
export * from "./FounderStorySection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__